import { useQuery } from 'convex/react';
import type { FunctionReturnType } from 'convex/server';
import { api } from '@aeon-karaoke/cloud-convex';
import { useCurrentUser } from './useCurrentUser';

export type PairedDevice = FunctionReturnType<typeof api.devices.mine>[number];

/** The TVs paired to the caller, oldest first. Skips until the users row exists. */
export function useMyDevices() {
  const { user } = useCurrentUser();
  return useQuery(api.devices.mine, user ? {} : 'skip');
}
